const SUPPORTED_FILE_TYPES = {
    // Images
    IMAGE: {
        extensions: ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.tiff'],
        mimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/tiff'],
        maxSize: 20 * 1024 * 1024, // 20MB
    },
    // Documents
    DOCUMENT: {
        extensions: ['.pdf', '.doc', '.docx', '.txt', '.rtf', '.odt'],
        mimeTypes: [
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'text/plain',
            'application/rtf',
            'application/vnd.oasis.opendocument.text',
        ],
        maxSize: 25 * 1024 * 1024, // 25MB
    },
    // Data files
    DATA: {
        extensions: ['.csv', '.json', '.xml', '.yaml', '.yml'],
        mimeTypes: [
            'text/csv',
            'application/json',
            'application/xml',
            'text/xml',
            'application/x-yaml',
            'text/yaml',
        ],
        maxSize: 15 * 1024 * 1024, // 15MB
    },
    // Code files
    CODE: {
        extensions: ['.js', '.py', '.java', '.cpp', '.c', '.cs', '.rb', '.php', '.html', '.css'],
        mimeTypes: [
            'text/javascript',
            'text/x-python',
            'text/x-java',
            'text/x-c',
            'text/x-csharp',
            'text/x-ruby',
            'text/x-php',
            'text/html',
            'text/css',
        ],
        maxSize: 5 * 1024 * 1024, // 5MB
    }
};

// Helper function to get all supported extensions
const getAllSupportedExtensions = () => {
    return Object.values(SUPPORTED_FILE_TYPES)
        .flatMap(type => type.extensions)
        .join(',');
};

export const getAcceptedFileTypes = isImageUploadEnabled => {
    const allTypes = SUPPORTED_FILE_TYPES;
    if (!isImageUploadEnabled) {
        const { IMAGE, ...nonImageTypes } = allTypes;
        return Object.values(nonImageTypes)
            .flatMap(type => type.extensions)
            .join(',');
    }
    return getAllSupportedExtensions();
};
